module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oECAn2/images/cover.jpg?1684255621833",
      "alt": "This image is the cover for the book Consider the Women"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Consider the Women\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("A timely and compelling new look at three key women in the biblical narrative ")])]), _c('p', [_vm._v("Among the mostly male-dominated narratives in Scripture, the stories of women can be game-changing. In this book Debbie Blue looks closely at Hagar (mother of Islam), Esther (Jewish heroine), and Mary (Christian matriarch)—and finds in them unexpected and inviting new ways of navigating faith and life. ")]), _c('p', [_vm._v("As she sets out to explore these biblical characters who live and move in places and ways outside of the strict boundaries of tradition, Blue encounters many real life characters who challenge her expectations and renew her hope—a Muslim tattoo artist, a Saudi Arabian sculptor, a rabbi in a Darth Vader costume, Aztec dancers at a feast of Guadalupe, an Islamic feminist scholar, and more.")]), _c('p', [_vm._v("Readers who embark with Blue on the sometimes unorthodox, subversive paths of these curious and lively figures will be led to envision more expansive and hopeful possibilities for faith, human connection, and love in our divided, violent world.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Debbie Blue\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0